<template>
  <div
    class="home-wrap"
    :class="getCurThemeType == 'enWrap' ? 'enWrap-font-wrap' : ''"
  >
    <div class="page1-wrap page-same">
      <p class="b-title">
        <span class="a-span">{{ $t("home.homeTitle1") }}</span>
        <span class="b-span">{{ $t("home.homeTilte2") }}</span>
        <span class="c-span">{{ $t("home.homeTilte3") }}</span>
        <span class="d-span">{{ $t("home.homeTilte4") }}</span>
      </p>
    </div>
    <div class="page2-wrap page-same">
      <div class="pic-wrap"></div>
      <div class="introduction">
        <div class="title">{{ $t("home.homeTilte5") }}</div>
        <div class="depict">{{ $t("home.page1Text") }}</div>
      </div>
    </div>
    <div class="page3-wrap page-same">
      <div class="w">
        <div class="title">{{ $t("home.homeTilte6") }}</div>
      </div>
    </div>
    <div class="page4-wrap page-same">
      <div class="w">
        <div class="project-box">
          <div
            class="list-wrap"
            v-for="(item, index) in projectList"
            :key="index"
            :class="'list-' + index"
          >
            <div class="item-wrap">
              <div class="title" v-html="$t('home.' + item.title)"></div>
              <div class="srk" v-html="$t('home.' + item.text)"></div>
            </div>
          </div>
        </div>
        <div class="immigration">
          <div class="left-title">
            <span v-html="$t('home.page4Title1')"></span>
          </div>
          <div class="right-intro">
            <span></span>
            <span></span>
            <div class="srk">{{ $t("home.page4Text1") }}</div>
          </div>
          <div class="conduct">
            <div class="item" @click="goUrl">
              {{ $t("home.page4Title2") }} <i class="iconfont icon-dianji"></i>
            </div>
            <div class="item" @click="goUrl1">
              {{ $t("home.page4Title3") }} <i class="iconfont icon-dianji"></i>
            </div>
          </div>
        </div>
        <div class="customized">
          <div class="c-left-wrap">
            <div class="title">{{ $t("contact.title") }}</div>
            <div class="list-wrap">
              <div
                class="item-wrap"
                v-for="(item, index) in contactList"
                :key="index"
              >
                <div class="pic"><img :src="item.pic" alt="" /></div>
                <div class="r-wrap">
                  <div
                    class="title-item"
                    v-html="$t('contact.' + item.title)"
                  ></div>
                  <div
                    class="text-item"
                    v-html="$t('contact.' + item.text)"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="b-right-wrap">
            <div class="map" id="coordinates" ref="basicMapbox">
              <img src="../../assets/img/home/map.png" alt="" />
            </div>
          </div>
          <div class="look">
            {{ $t("base.look") }} <i class="iconfont icon-Fill1"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  metaInfo: {
    title: "KrngPartners", // set a title
    meta: [
      {
        name: "",
        content: "",
      },
      {
        name: "description",
        content: "",
      },
    ],
  },
  data() {
    return {
      projectList: [
        { title: "page2Title1", text: "page2Text1" },
        { title: "page2Title2", text: "page2Text2" },
        { title: "page2Title3", text: "page2Text3" },
        { title: "page2Title4", text: "page2Text4" },
        { title: "page2Title5", text: "page2Text5" },
        { title: "page2Title6", text: "page2Text6" },
      ],
      contactList: [
        {
          title: "title1",
          text: "text1",
          pic: require("../../assets/img/home/internet.png"),
        },
        {
          title: "title2",
          text: "text2",
          pic: require("../../assets/img/home/mail.png"),
        },
        {
          title: "title3",
          text: "text3",
          pic: require("../../assets/img/home/location.png"),
        },
      ],
    };
  },
  computed: {},
  created() {},
  methods: {
    goUrl() {
      window.location.href =
        "https://www.mara.gov.au/tools-for-agents-subsite/Files/code-of-conduct-march-2022.pdf";
    },
    goUrl1() {
      window.location.href =
        "https://www.mara.gov.au/get-help-with-a-visa/help-from-registered-agents/steps-to-choose/consumer-guide";
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "home.scss";
@import url("https://api.tiles.mapbox.com/mapbox-gl-js/v0.44.2/mapbox-gl.css");
</style>
